import type { PressCheckBoxListProps } from './interfaces';
import styles from './PressCheckBoxList.module.scss';
import CheckBox from '../../CheckBox/CheckBox';
import clsx from 'clsx';

const PressCheckBoxList = ({
  items,
  selectedItems = [],
  onClick,
}: PressCheckBoxListProps) => {
  const onSelectionItemClick = (index: number) => {
    onClick(items[index]);
  };

  const selectionItems = items.map((item, index) => (
    <div
      key={item}
      className={clsx(styles.item, {
        [styles.active]: selectedItems.includes(item),
      })}
      onClick={() => onSelectionItemClick(index)}
    >
      <CheckBox
        checked={selectedItems.includes(item)}
        onChange={function noRefCheck() {
          return;
        }}
      />
      <span className={styles.text}>{item}</span>
    </div>
  ));

  return <div className={styles.base}>{selectionItems}</div>;
};

export default PressCheckBoxList;
